/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */

import { axiosWebservice } from './setup';
import qs from 'qs';

export async function verifyDomain (url) {
  const webservice = axiosWebservice();

  const response = await webservice.post(
    'domains/verify',
    qs.stringify({
      url: url
    })
  );
  return response &&
    response.data &&
    response.data.status &&
    response.data.appurl
    ? response.data.appurl
    : null;
}

export async function getAllDomains () {
  const webservice = axiosWebservice();

  const response = await webservice.get('domains');
  return response &&
    response.data &&
    response.data.status &&
    response.data.domains
    ? response.data.domains
    : [];
}
